import Entity from "@/store/entities/entity";
import JobDocumentRequestContactVm from "@/store/entities/jobcontext/jobdocumentrequestcontactvm";

export default class JobDocumentRequestVm extends Entity<number> {
    jobId: number;
    contacts: Array<JobDocumentRequestContactVm>
}
